<template>
  <div class="button-row-container">
    <div class="button-wrapper">
      <key-capture
        @keydown="handleKeyDown"
      ></key-capture>
      <footer-buttons
        class="footer-buttons-wrapper"
        :flashcard="flashcard"
        :category="category"
      ></footer-buttons>
      <span class="spacer"></span>
      <div
        v-if="showFlashcardStatuses"
        class="tag-wrapper"
      >
        <button
          v-for="status in answeredFlashcardStatuses"
          :key="status.id"
          class="button-choice"
          :data-test="`flashcard-status-${status.name}`"
          @click="tag(status.id)"
        >
          <icon
            name="tag-uui"
            :variant="status.name"
          ></icon>
          <span>{{ status.displayName }}</span>
        </button>
        <pop-over
          v-if="showChooseTagsPopover"
          use-circle
          icon-name="tag-uui-white"
        >
          <template v-slot:header>
            <span>Choose a tag to continue</span>
          </template>
          Tags can be used to sort and review questions later.
        </pop-over>
      </div>
      <button
        v-else
        class="button-choice"
        @click="tag(greenFlashcardStatus.id)"
      >
        Next Question
      </button>
    </div>
  </div>
</template>

<script>
import Icon from '@/components/singletons/icon';
import FooterButtons from '@/components/flashcards-v2/fragments/FooterButtons.vue';
import KeyCapture from '@/components/singletons/KeyCapture';
import PopOver from '@/components/singletons/PopOver';

export default {
  components: {
    Icon,
    FooterButtons,
    KeyCapture,
    PopOver,
  },
  props: {
    category: {
      type: Object,
      default: () => {},
    },
    flashcard: {
      type: Object,
      default: () => {},
    },
    showFlashcardStatuses: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    answeredFlashcardStatuses() {
      return [...this.$store.getters['flashcardStatuses/answeredFlashcardStatuses']]
        .sort((a, b) => a.order - b.order);
    },
    greenFlashcardStatus() {
      return this.$store.getters['flashcardStatuses/greenFlashcardStatus'];
    },
    showChooseTagsPopover() {
      return this.$store.getters['flashcardStates/flashcardStateList'].length === 0;
    },
  },
  methods: {
    tag(flashcardStatusId) {
      this.$emit('tag', flashcardStatusId);
    },
    handleKeyDown(key) {
      if (key.length != 1) return;

      const matchingStatus = this.answeredFlashcardStatuses.find(
        status => status.displayName.toUpperCase()[0] === key.toUpperCase()
      );
      if (matchingStatus) {
        this.tag(matchingStatus.id);
      }
  },
  },
};
</script>

<style lang="scss" scoped>
.button-row-container {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 72px;

  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: rem-calc(8);
  justify-content: center;
  padding: 1rem;
  background-color: #F9FAFB;
  z-index: 10;

  .button-wrapper {
    grid-column: 1 / 13;
    display: flex;
    flex-direction: row;
    gap: rem-calc(8);
    flex-grow: 1;
  }
  .tag-wrapper {
    position: relative;
    display: flex;
    gap: rem-calc(8);
  }

  .button-choice {
    background-color: white;
    border: 1px solid #e3e8ef;
    border-radius: rem-calc(6);
    color: #232323;
    // flex box properties
    display: flex;
    align-items: center;
    justify-content: center;
    gap: rem-calc(6);
    // text properties
    font-size: rem-calc(12);
    font-weight: 600;
    line-height: rem-calc(16);
    padding: rem-calc(8) rem-calc(8);
    white-space: nowrap;
    flex-grow: 1;
  }

  .footer-buttons-wrapper {
    display: none;
  }
}

@include breakpoint(tablet) {
  .button-row-container {
    left: rem-calc(88);
    bottom: 0;
    margin-bottom: 1rem;

    .button-wrapper {
      justify-content: center;
    }

    .button-choice {
      flex-grow: 0;
      justify-content: center;
      font-size: rem-calc(16);
      line-height: rem-calc(24);
      padding: rem-calc(8) rem-calc(16);
    }

    .footer-buttons-wrapper {
      display: flex;
    }

    .spacer {
      flex-grow: 1;
    }
  }
}

@include breakpoint(desktop) {
  .button-row-container {
    left: rem-calc(88);
    bottom: 0;
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    gap: rem-calc(32);
    margin-right: 2rem;
    margin-left: 2rem;
    margin-bottom: 2rem;
    padding: 0;


    .button-wrapper {
      grid-column: 5 / 13;
    }

    .footer-buttons-wrapper {
      display: flex;
    }

    .button-choice {
      flex-grow: 0;
      justify-content: center;
      font-size: rem-calc(16);
      line-height: rem-calc(24);
      padding: rem-calc(8) rem-calc(16);
    }

    .spacer {
      flex-grow: 4;
    }

    .button-choice {
      flex-grow: 0;
    }
  }
}
</style>
